export default {
    NOT_NEED: "0", // 否
    NEED: "1", // 要
}
